import React from 'react'

const CircleRedSvg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 13 13'
    >
      <circle
        id='Ellipse_222'
        data-name='Ellipse 222'
        cx='6.5'
        cy='6.5'
        r='6.5'
        fill='#cb3030'
      />
    </svg>
  )
}

export default CircleRedSvg
